export default __webpack_public_path__ + "static/media/bullseye.92a23675.svg";